var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLiveV2 = function SvgLiveV2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10995 0.0556057C7.18946 0.101703 7.251 0.173403 7.28449 0.258993C7.31799 0.344583 7.32147 0.439004 7.29437 0.526829L5.83114 5.28131H8.53093C8.61027 5.28128 8.68788 5.30448 8.75419 5.34805C8.82049 5.39163 8.87258 5.45366 8.90403 5.5265C8.93549 5.59934 8.94492 5.6798 8.93117 5.75794C8.91742 5.83608 8.88109 5.90848 8.82666 5.96621L2.32703 12.8721C2.26414 12.9389 2.18045 12.9825 2.08961 12.9958C1.99877 13.009 1.90612 12.991 1.82678 12.9449C1.74743 12.8987 1.68607 12.827 1.65269 12.7415C1.6193 12.656 1.61587 12.5617 1.64294 12.474L3.10617 7.71867H0.406389C0.327049 7.7187 0.249436 7.6955 0.183131 7.65193C0.116827 7.60835 0.0647335 7.54632 0.0332818 7.47348C0.00183012 7.40064 -0.00760289 7.32018 0.00614716 7.24204C0.0198972 7.1639 0.0562283 7.0915 0.110656 7.03377L6.61029 0.127914C6.6731 0.0611297 6.75666 0.0175574 6.84737 0.00428187C6.93809 -0.00899367 7.03063 0.00880831 7.10995 0.0547933V0.0556057Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLiveV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/live-v2.f0e10c20.svg";
export { ForwardRef as ReactComponent };